import api, { handleResponse, handleError } from './api';

const regionService = {
  /**
   * The region containing a point. Lets callers that need a regionId be driven
   * by a city search instead of scanning the region list.
   * A 404 means no region covers that city — a real answer, not a failure.
   */
  async forCoords(lat, lng) {
    try {
      const response = await api.get(`/regions/for-coords?lat=${encodeURIComponent(lat)}&lng=${encodeURIComponent(lng)}`);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /**
   * A page of regions, optionally filtered by name/slug. There are ~69k of them,
   * so browsing the list has to be paged; the endpoint caps `take` server-side.
   */
  async search({ q = '', skip = 0, take = 100 } = {}) {
    try {
      const params = new URLSearchParams();
      if (q && q.trim()) params.set('q', q.trim());
      params.set('skip', skip);
      params.set('take', take);
      const response = await api.get(`/regions?${params}`);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /** Admin-only: create a new region with bounding box. */
  async create(payload) {
    try {
      const response = await api.post('/regions', payload);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /** Admin-only: update region. */
  async update(id, payload) {
    try {
      const response = await api.put(`/regions/${id}`, payload);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },
};

export default regionService;
